import { render, staticRenderFns } from "./u-pagination-text-underline.vue?vue&type=template&id=77235f86&scoped=true&"
import script from "./u-pagination-text-underline.vue?vue&type=script&lang=js&"
export * from "./u-pagination-text-underline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77235f86",
  null
  
)

export default component.exports